export const CONTRACT_TEMPLATES_ERROR = 'CONTRACT_TEMPLATES_ERROR';
export const CONTRACT_TEMPLATES_GET = 'GET_CONTRACT_TEMPLATES_INIT';
export const CONTRACT_TEMPLATES_GET_ALL = 'CONTRACT_TEMPLATES_GET_ALL';
export const CONTRACT_TEMPLATES_SAVE = 'GET_CONTRACT_TEMPLATES_SAVE';
export const CONTRACT_TEMPLATES_ADD_UPDATE = 'GET_CONTRACT_TEMPLATES_ADD_UPDATE';
export const CONTRACT_TEMPLATE_CLEAR = 'CONTRACT_TEMPLATE_CLEAR';
export const CONTRACT_TEMPLATE_CLEAR_ALL_UPDATES = 'CONTRACT_FEES_CLEAR_ALL_UPDATES';
export const CONTRACT_TEMPLATES_GET_RELATED_MARKINGTEAMS = 'CONTRACT_TEMPLATES_GET_RELATED_MARKINGTEAMS';
export const CONTRACT_TEMPLATES_REMOVE_ALL_EDITS = 'CONTRACT_TEMPLATES_REMOVE_ALL_EDITS';
